/**
 * HorseListEmptyState — état vide de « Mes Chevaux » (aucun cheval ACTIF).
 *
 * Deux titres selon que le compte n'a aucun cheval ou seulement des archivés ;
 * même appel à l'action dans les deux cas. Le CTA n'est rendu que si le parent
 * fournit `onAddHorse` (droit d'ajout décidé par la couche routing, pas ici).
 * Rendu délégué au bloc générique shared/EmptyState.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusCircle } from 'lucide-react';
import EmptyState from '../shared/EmptyState';

const HorseListEmptyState = ({ hasArchived, onAddHorse, darkMode }) => {
  const { t: tr } = useTranslation();
  return (
    <EmptyState
      title={tr(hasArchived ? 'horses.list.empty.noActiveTitle' : 'horses.list.empty.title')}
      subtitle={tr('horses.list.empty.subtitle')}
      primaryAction={onAddHorse && { label: tr('horses.list.empty.cta'), onClick: onAddHorse, Icon: PlusCircle }}
      darkMode={darkMode}
    />
  );
};

export default HorseListEmptyState;
